import React from 'react';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import { IconButton, Tooltip } from '@mui/material';
import { MeetingDto } from '../../services/dtos/meeting.dto';

/**
 * Boutton du tableau qui permet d'obtenir les documents
 * @param props
 * @constructor
 */
export default function GetFiles(
    props: Readonly<{
        meeting: MeetingDto;
        handlerGetMeetingFiles: (meeting: MeetingDto) => void;
    }>
) {
    // retourne de bouton doc icon pour avoir aux doc d'une réunion
    return (
        <>
            {props.meeting.hasDocument && (
                <Tooltip title="Voir les documents associes">
                    <IconButton
                        data-testid={'get-docs-icon'}
                        aria-label="Voir les documents"
                        onClick={() => props.handlerGetMeetingFiles(props.meeting)}
                        size="small"
                        sx={{
                            border: '1px solid #d9e3ef',
                            borderRadius: '12px',
                            color: '#305b8d',
                            padding: '8px',
                        }}
                    >
                        <InsertDriveFileOutlinedIcon />
                    </IconButton>
                </Tooltip>
            )}
        </>
    );
}
